// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SuggestionCard-cls1___a5b5ab561ef80c8c95c{/*!*/}.SuggestionCard-cls2___1865cfbd7ca8197362b{flex-grow:1}.SuggestionCard-cls2___1865cfbd7ca8197362b.SuggestionCard-small___26f97ae489aa4da7cd7{margin-bottom:4px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "SuggestionCard-cls1___a5b5ab561ef80c8c95c",
	"cls2": "SuggestionCard-cls2___1865cfbd7ca8197362b SuggestionCard-cls1___a5b5ab561ef80c8c95c",
	"small": "SuggestionCard-small___26f97ae489aa4da7cd7"
};
export default ___CSS_LOADER_EXPORT___;
